import colors from '@theme/colors';
import { StyleSheet } from 'react-native';

const styles = StyleSheet.create({
  accountListStyle: { alignSelf: 'stretch' },
  emptyStateContainer: {
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: 100,
    padding: 20,
  },
  flatListContent: {
    flexGrow: 1,
  },
  modalContainer: {
    marginHorizontal: 10,
  },
  modalContent: {
    backgroundColor: colors.neutral.cotton,
    borderTopLeftRadius: 20,
    borderTopRightRadius: 20,
    flexShrink: 1,
    maxHeight: '90%',
  },
  modalOverlay: {
    backgroundColor: colors.overlay.backdrop,
    flex: 1,
    justifyContent: 'flex-end',
  },
});
export default styles;
